import React, {Component} from 'react';
import styles from './Logo.scss';
import CirrusMEDIcon from '../controls/icons/CirrusMEDIcon';

export default function Logo({homePageOpened}) {
    return (
        <div className={styles.logoContainer}>
            <div className={styles.logo} />
            <div className={styles.logoText}>
                <CirrusMEDIcon className={homePageOpened && styles.homePageLogo}/>
                {!homePageOpened && (<div className={styles.email}>{loc('our-email')}</div>)}
            </div>
        </div>

    );
}



// WEBPACK FOOTER //
// ./src/components/Header/Logo.js